import { SHOW_FIT_OPTIONS } from 'events';
import { component } from 'picoapp';

export default component(async (node, ctx) => {
  const showFitOptions = node.querySelector('[data-show-fit-options]');

  if (showFitOptions) {
    showFitOptions.addEventListener('click', () => {
      ctx.emit(SHOW_FIT_OPTIONS, null, showFitOptions.dataset.showFitOptions);
    });
  }
});
